import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import colorContrast from 'color-contrast';
import * as R from 'ramda';
import { GetPartnerLogo } from './../../actions/partner/partner';

import logo_hr from './../../assets/images/brand/assista_horizontal-punchout.svg';

export const Navbar = ({ user, partner, etablissement, profilePicture, isPartner, userInfo, showSerenita }) => {
    const router = useSelector(state => state.router);


    const [logo, setLogo] = useState(logo_hr);

    if (partner.hasLogo) {
        GetPartnerLogo(partner.id).then((resp) => {
            setLogo(resp);
        });
    }
    if (R.isNil(user)) {
        return "";
    }

    return (
			<React.Fragment>
				<header className={"aside navbar navbar-expand-lg py-4" + (!R.isNil(partner.color) && partner.color !== "" ? (colorContrast("#fff", partner.color) >= 2.5 ? " text-white navbar-dark" : " navbar-light") : " text-white navbar-dark")}>
					<div className="container-fluid px-gutter justify-content-between align-item-center d-lg-flex flex-lg-column h-100">
						<Link className="navbar-brand mx-lg-auto mb-lg-auto rounded-sm" to="/">
							{partner.hasLogo ? <img className="img-fluid rounded-sm img-avatar" src={logo} alt="Assist@ partner" height="80" width="100%" /> : <img className="img-fluid" src={logo} alt="Assist@" width="180" />}
							{/* <img className="img-fluid d-none d-lg-block" src={logo} alt="Assist@" width="146" /> */}
							<h1 className="sr-only visually-hidden">Assist@: Menu</h1>
						</Link>
						<div className="d-flex align-items-center">
							<button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
								<span className="navbar-toggler-icon"></span>
							</button>
						</div>
						<div className={"collapse navbar-collapse flex-column mt-4"} id="navbar-collapse">
							<nav className={"card w-100 rounded-cta flex-grow-0 mb-auto h-100 border-0" + (!R.isNil(partner.color) && partner.color !== "" ? (colorContrast("#fff", partner.color) >= 2.5 ? " bg-stage" : " bg-pale") : " bg-stage")}>
								<h1 className="sr-only visually-hidden">Menu: navigation</h1>
								<div className="nav-item text-center">
									<div className="h3 font-weight-bold lh-1 mt-3">{!R.isNil(user) ? `${user.firstName} ${user.lastName}` : "The Partner"}</div>
									<ul className="nav navbar-inline align-items-center justify-content-around container-paper mx-auto">
										<div
											role="button"
											className={"nav-item inline-item o-70 o-100--hover"}
											onClick={() => {
												localStorage.removeItem("access_token");
												setTimeout(() => {
													window.location = "/index";
												}, 100);
											}}>
											<div className="nav-link p-2 mb-0 lh-1">
												<i className="eva eva-power-outline h3 lh-1 my-auto icon-default"></i>
											</div>
										</div>
									</ul>
								</div>
								<div className="nav-item show">
									<ul className="card-body pb-0 navbar-nav">
										<NavLink className="nav-item og-item" activeClassName="active text-white" to="/funecap/dossiers">
											<div className={"nav-link d-flex w-100 justify-content-between mb-0 text-inherit" + (router.location.pathname === "/funecap/dossiers" ? "" : " o-70")}>
												<span className="font-weight-black text-uppercase">Dossiers</span>
												<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
											</div>
										</NavLink>
										{isPartner ? (
											<>
												<NavLink className="nav-item" activeClassName="active text-white" to="/funecap/teleconseillers">
													<div className={"nav-link grid grid-2 gx-2 w-100 justify-content-between mb-0 text-inherit" + (router.location.pathname === "/funecap/teleconseillers" ? "" : " o-70")}>
														<span className="font-weight-black text-uppercase">Chargés</span>
														<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
													</div>
												</NavLink>
												<NavLink className="nav-item" activeClassName="active text-white" to="/funecap/audit">
													<div className={"nav-link grid grid-2 gx-2 w-100 justify-content-between mb-0 text-inherit" + (router.location.pathname === "/funecap/audit" ? "" : " o-70")}>
														<span className="font-weight-black text-uppercase pr-3">Audit</span>
														<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
													</div>
												</NavLink>
											</>
										) : (
											""
										)}
									</ul>
								</div>
							</nav>
						</div>
					</div>
				</header>
			</React.Fragment>
		);
};